import { SchemaField } from '../../generic/serialization/schema-field';
import { VoiceResponseCommandName } from '../any-voice-response-command/voice-response-command-name';
import { VoiceResponseCommandSchema } from '../generic/voice-response-command-schema';

export class EnforceServiceLimitSchema extends VoiceResponseCommandSchema {
  // Unique identifier of the audio file internally to the database
  public static readonly serviceLimitId = 'serviceLimitId';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class {
    public static readonly commandName = VoiceResponseCommandName.enforceServiceLimit;

    public static readonly serviceLimitId = undefined;
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Schema for this object is encoded into a command name, and in parameters
   */
  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } | import('joi').AnySchema {
    const parameters = {} as any;

    /* eslint-disable */
    parameters[VoiceResponseCommandSchema.commandName] = SchemaField.string(
      EnforceServiceLimitSchema.Defaults.commandName,
    );
    parameters[EnforceServiceLimitSchema.serviceLimitId] = SchemaField.string(
      EnforceServiceLimitSchema.Defaults.serviceLimitId,
    );
    /* eslint-enable */

    return parameters;
  }
}
